export default {
  'billingSubscriptions.columns.companyName': 'Empresa / Nombre',
  'billingSubscriptions.columns.companyIdentity': 'Empresa / Identidad fiscal',
  'billingSubscriptions.fields.billingLegalName': 'Razón social de facturación',
  'billingSubscriptions.changePlan.action': 'Cambiar plan',
  'billingSubscriptions.changePlan.title': 'Cambiar plan',
  'billingSubscriptions.changePlan.currentPlan': 'Plan actual',
  'billingSubscriptions.changePlan.newPlan': 'Plan nuevo',
  'billingSubscriptions.changePlan.confirmTitle': '¿Cambiar el plan de la empresa?',
  'billingSubscriptions.changePlan.immediate':
    'La configuración y los límites del plan nuevo se aplican de inmediato.',
  'billingSubscriptions.changePlan.success': 'El plan se cambió correctamente.',
  'billingSubscriptions.changePlan.includedCredit': 'Crédito de IA incluido del mes',
  'billingSubscriptions.suspension.suspend': 'Suspender',
  'billingSubscriptions.suspension.reactivate': 'Reactivar',
  'billingSubscriptions.suspension.suspendTitle': '¿Suspender la suscripción de {company}?',
  'billingSubscriptions.suspension.reactivateTitle': '¿Reactivar la suscripción de {company}?',
  'billingSubscriptions.suspension.suspendMessage':
    'Revisa el impacto antes de confirmar la suspensión.',
  'billingSubscriptions.suspension.reactivateMessage':
    'Esto restablece esta empresa. El backend recalcula su estado de facturación, que puede quedar pendiente de pago, vencido o activo. Un actor comercial suspendido vuelve a activo; esto no es una aprobación.',
  'billingSubscriptions.suspension.helpCompanyOnly':
    'Esta acción suspenderá únicamente a esta empresa y bloqueará su acceso y operación comercial.',
  'billingSubscriptions.suspension.helpNoCascade':
    'Las empresas relacionadas no serán suspendidas. Actualmente tiene {actors} actores comerciales y {customers} clientes asociados.',
  'billingSubscriptions.suspension.helpPayment':
    'Los pagos iniciados antes de la suspensión podrán completarse, pero no reactivarán la suscripción.',
  'billingSubscriptions.suspension.reason': 'Motivo de suspensión',
  'billingSubscriptions.suspension.reasonPlaceholder':
    'Explica por qué se suspende esta suscripción.',
  'billingSubscriptions.suspension.reasonCounter': '{current}/{maximum} caracteres',
  'billingSubscriptions.suspension.suspendedAt': 'Suspendida el',
  'billingSubscriptions.suspension.suspendedBy': 'Suspendida por',
  'billingSubscriptions.suspension.lastReactivatedAt': 'Última reactivación',
  'billingSubscriptions.suspension.lastReactivatedBy': 'Reactivada por',
  'billingSubscriptions.suspension.commercialActorKind': 'Tipo de actor comercial',
  'billingSubscriptions.suspension.commercialActorStatus': 'Estado del actor comercial',
  'billingSubscriptions.suspension.descendantActors': 'Actores descendientes',
  'billingSubscriptions.suspension.descendantCustomers': 'Clientes descendientes',
};
